const Banner = () => {
  return (
    <div className="bannerProductBiz mt-3">
      <h5 className="text-white fw-700 fs-44 lh-160">Eureka Biz</h5>
      <div className="text-white fw-500 fs-24 lh-160">helps corporates to develop their business and contributes to improving the country's economy.</div>
    </div>
  )
}

export default Banner;